'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res6, _Component);

  function Module2Res6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res6.__proto__ || (0, _getPrototypeOf2.default)(Module2Res6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Sample shopping list'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module2Res6, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, xs: 12, sm: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { striped: true, bordered: true, hover: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement('th', null),
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Fridge/Freezer'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Grocery'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Weetbix, Oats, Bread (wholegrain)',
                    _react2.default.createElement('br', null),
                    'English muffins(wholemeal)',
                    _react2.default.createElement('br', null),
                    'Pasta, Brown Rice, Eggs',
                    _react2.default.createElement('br', null),
                    'Tinned tuna, Baked beans'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Tinned peaches, Nut butter (eg. almond)'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Hummus, ice cream',
                    _react2.default.createElement('br', null),
                    'Frozen peas and corn,',
                    _react2.default.createElement('br', null),
                    'Frozen green beans, frozen mixed stir-fry vegies,',
                    _react2.default.createElement('br', null),
                    'Frozen mixed berries'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Fruit and vegetables'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Banana, kiwifruit, apples',
                    _react2.default.createElement('br', null),
                    'grapes, mandarins, strawberries'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Celery, lettuce, carrot, tomatoes',
                    _react2.default.createElement('br', null),
                    'Onion, potato, pumpkin'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Broccoli, capsicum'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Dinner'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Chicken breast, lamb chops, beef mince'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Fish (salmon)'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '\xA0'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Deli/Dairy'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Ham, yoghurt, cheese',
                    _react2.default.createElement('br', null),
                    'Cottage cheese, milk'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '\xA0'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '\xA0'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res6.js
// module id = 1243
// module chunks = 0